const binding = { modules: {}, dataActions: {} };

    (binding.modules['eve-video-links'] = {
        c: () => require('partner/modules/eve-video-links/eve-video-links.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-video-links',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-video-links'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eve-video-links|eve-video-links'] = {
                c: () => require('partner/modules/eve-video-links/eve-video-links.view.tsx'),
                cn: '__local__-__local__-eve-video-links'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };